export enum LearningAnswerType {
  correct,
  incorrect,
}
